/**
 * @desc Truncates the string to the specified length and returns the truncated string postfixed with ellipsis character
 */
export const truncate = (text: string, { length }: { length: number }): string => {
  return text.length > length ? `${text.substring(0, length)}…` : text
}

export const formatNumber = (number: number, { precision }: { precision?: number } = {}): string => {
  const options = {
    maximumFractionDigits: precision,
    minimumFractionDigits: precision,
  }

  const formatter = Intl.NumberFormat(i18n.locale, options)

  if ('format' in formatter) {
    return formatter.format(number)
  }

  // fallback
  return number.toString()
}
